<template>
    <span>{{ title }}</span>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: "GearTitle",
    props: ["gearId"],
    computed: {
        ...mapState(['gear']),
        title() {
            var gear = this.gear.find(g => g.id === this.gearId)
            return gear.brand+' '+gear.title
        }
    },
}
</script>